import styled from 'styled-components'

import { SHADOW_LV1 } from 'styles/constants'
import { elementStyle } from 'styles/element-style'

const StyledCard = styled.div<IElement>`
  ${elementStyle}

  background-color: white;
  box-shadow: ${SHADOW_LV1};
`

type CardProps = IElement

export const Card: React.FC<CardProps> = ({ children, ...props }) => (
  <StyledCard {...props}>{children}</StyledCard>
)
